// extracted by mini-css-extract-plugin
export default {"content":"ArticleContent_content__O3SRr"};